import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import PaginationComponent from './Pagination.component';
import ToolbarComponent from './Toolbar.component';
import SelectComponent from '@ui/components/Select/Select.component';
import useDictionary from '@ui/hooks/useDictionary';
import { IProps as IMainProps } from './IProps';
import { variants } from '@ui/components/Select/variants.enum';
import { lang } from '@lang/interfaces/lang';

export interface IClasses {
    tooltipPopper?: string;
    tooltip?: string;
    btnDownload?: string;
    ico?: string;
    btnVisibility?: string;
    btnBar?: string;
    tablePaginationInputWrap?: string;
    tablePaginationInputTitle?: string;
    tablePaginationInput?: string;
    tablePaginationInputItem?: string;
    tablePagination?: string;
    tablePaginationActions?: string;
    tablePaginationRowsLabel?: string;
    tablePaginationSelectLabel?: string;
}

export interface IProps
    extends Pick<
            IMainProps,
            'lang' | 'page' | 'limit' | 'loading' | 'onPageChange'
        >,
        Partial<
            Pick<
                IMainProps,
                | 'onDownloadClick'
                | 'onLimitChange'
                | 'onVisibilitySettingsStateChange'
            >
        > {
    classes?: IClasses;
    dataLength: number;
    hideSettings?: boolean;
    hideDownload?: boolean;
}

const Component: React.FC<IProps> = ({
    classes,
    lang,
    page,
    limit,
    loading,
    dataLength,
    hideSettings,
    hideDownload,
    onDownloadClick,
    onVisibilitySettingsStateChange,
    onPageChange,
    onLimitChange,
}: IProps) => {
    const getWord = useDictionary();
    const isTelemetryEmpty = dataLength === 0;
    const toolbar = (
        <ToolbarComponent
            classes={{
                tooltipPopper: classes?.tooltipPopper,
                tooltip: classes?.tooltip,
                btnDownload: classes?.btnDownload,
                ico: classes?.ico,
                btnVisibility: classes?.btnVisibility,
                btnBar: classes?.btnBar,
            }}
            lang={lang}
            hideSettings={hideSettings ?? false}
            hideDownload={hideDownload ?? false}
            onDownloadClick={onDownloadClick}
            onVisibilitySettingsStateChange={onVisibilitySettingsStateChange}
        />
    );

    const limits = [50, 100, 250, 500, 1000];

    return (
        <Box className="telemetry__footer">
            {!(isTelemetryEmpty || loading) && toolbar}
            {!!dataLength && (
                <Box className={classes?.tablePaginationInputWrap}>
                    <Typography className={classes?.tablePaginationInputTitle}>
                        {`${getWord('rowsPerPage')}:`}
                    </Typography>
                    <SelectComponent
                        lang={lang}
                        value={limit}
                        values={limits}
                        variant={variants.footer}
                        onChange={onLimitChange}
                    />
                </Box>
            )}
            <PaginationComponent
                classes={{
                    tablePagination: classes?.tablePagination,
                    tablePaginationActions: classes?.tablePaginationActions,
                    tablePaginationRowsLabel: classes?.tablePaginationRowsLabel,
                    tablePaginationSelectLabel:
                        classes?.tablePaginationSelectLabel,
                }}
                lang={lang}
                page={page}
                limit={limit}
                dataLength={dataLength}
                onPageChange={onPageChange}
            />
        </Box>
    );
};

const FooterComponent = React.memo(Component);

export default FooterComponent;
